// Business constants for MP Carrosserie
export const BUSINESS = {
  name: "MP Carrosserie",
  legalName: "MP Carrosserie Inh. Müller Dominic",
  owner: "Dominic Müller",
  ownerFull: "Müller, Dominic-Mathias",
  coOwner: "Carmine Petretta",
  address: "Milchgasse 4",
  city: "4628 Wolfwil",
  country: "Schweiz",
  canton: "Solothurn",
  email: "info@mp-carrosserie.ch",
  emailOwner: "mueller@mp-carrosserie.ch",
  emailCo: "petretta@mp-carrosserie.ch",
  phoneOffice: "+41 62 926 40 00",
  phoneOwner: "+41 79 926 40 00",
  phoneCo: "+41 79 926 40 09",
  uid: "CHE-339.965.996",
  registeredOn: "28.10.2025",
  legalForm: "Einzelunternehmen",
  purposes: [
    "Betrieb einer Autogarage",
    "Carrosserie-, Lackier- und Servicearbeiten an Fahrzeugen",
    "Handel mit Fahrzeugen aller Art",
  ],
  instagramHandle: "mp_carrosserie_wolfwil",
  instagramUrl: "https://www.instagram.com/mp_carrosserie_wolfwil",
  whatsappNumber: "41799264009",
  whatsappUrl:
    "https://wa.me/41799264009?text=Gr%C3%BCezi%20MP%20Carrosserie%2C%20ich%20habe%20eine%20Anfrage",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Milchgasse+4+4628+Wolfwil",
  mapsEmbed:
    "https://www.google.com/maps?q=Milchgasse+4,+4628+Wolfwil,+Schweiz&output=embed",
  logoUrl: "/mp-logo.svg",
  brandRed: "#e52620",
};

// Local videos (empty by default). User uploads real workshop videos to /app/frontend/public/videos/
// and references them as "/videos/bodywork.mp4" etc. Empty string disables the <video> tag —
// the poster image is then shown instead.
export const VIDEOS = {
  hero: "",
  bodywork: "",
  painting: "",
  accident: "",
};

export const POSTERS = {
  hero: "/hero-supercar.jpeg",
  bodywork: "/gallery/fingerprint-tank.jpeg",
  painting: "/gallery/ducati-red.jpeg",
  accident: "/gallery/italia-white.jpeg",
  workshop: "/gallery/yamaha-tank.jpeg",
  texture:
    "https://static.prod-images.emergentagent.com/jobs/d9684c60-8d85-459f-ba71-47012b1f729c/images/ad73ec0a11ded7f1152a1a98768b5b06adee421b4a010e81d3b2ff133a9bbab3.png",
};

// Real project photos shown in the Instagram marquee — only our own MP work
export const INSTAGRAM_GRID = [
  "/gallery/rim-orange.jpeg",
  "/gallery/yamaha-tank.jpeg",
  "/gallery/fingerprint-tank.jpeg",
  "/gallery/ducati-red.jpeg",
  "/gallery/italia-white.jpeg",
];
